const CandidatesIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="4.5" r="2.2" fill="currentColor" />
    <path d="M6.8 8.5C6.8 7.3 7.9 6.5 9.1 6.5H10.9C12.1 6.5 13.2 7.3 13.2 8.5V10H6.8V8.5Z" fill="currentColor" />
    <circle cx="5" cy="11" r="2.2" fill="currentColor" />
    <path d="M1.8 15C1.8 13.8 2.9 13 4.1 13H5.9C7.1 13 8.2 13.8 8.2 15V16.5H1.8V15Z" fill="currentColor" />
    <circle cx="15" cy="11" r="2.2" fill="currentColor" />
    <path d="M11.8 15C11.8 13.8 12.9 13 14.1 13H15.9C17.1 13 18.2 13.8 18.2 15V16.5H11.8V15Z" fill="currentColor" />
  </svg>
);

export default CandidatesIcon;
